import React from 'react';
interface SectionHeaderProps {
  id: string;
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  dark?: boolean;
}
export function SectionHeader({
  id,
  eyebrow,
  title,
  description,
  dark = false
}: SectionHeaderProps) {
  return <div className="text-center" data-id="element-161" data-mp="22fpn3sqt6if3">
      {eyebrow && <p className={`text-xs font-extrabold uppercase leading-tight tracking-wide sm:text-sm ${dark ? 'text-amarillo' : 'text-wifi'}`} data-id="element-162" data-mp="27hyi0un8ruju">
          {eyebrow}
        </p>}
      <h2 id={id} className={`mt-1 font-display text-[1.65rem] uppercase leading-[1.08] sm:text-4xl ${dark ? 'text-white' : 'text-navy'}`} data-id="element-163" data-mp="3052gegrtxamn">
        {title}
      </h2>
      {description && <p className={`mx-auto mt-1 max-w-xl text-[0.82rem] leading-snug sm:text-base ${dark ? 'text-white/80' : 'text-negro/75'}`} data-id="element-164" data-mp="19t4uyq2ie2ah">
          {description}
        </p>}
    </div>;
}